// removed by extract-text-webpack-plugin
module.exports = {"homepage-img":"src-pages----index-module---homepage-img---11ltS","homepage-main-text":"src-pages----index-module---homepage-main-text---2hEPE","body-unscrollable":"src-pages----index-module---body-unscrollable---SM5_a"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.css
// module id = 995
// module chunks = 35783957827783